import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';

import { MARGIN_BOTTOM, MARGIN_TOP } from './constants';

const PriceCaloriesTitle = styled.h2`
  width: 100%;
  text-align: center;
  color: ${({ theme }) => theme.token('text-default')};
  font: ${brandFont.headerOne};
  margin-top: ${MARGIN_TOP};
  margin-bottom: ${MARGIN_BOTTOM};
  font-weight: ${Styles.fontWeight.normal};
  letter-spacing: 'normal';
  text-transform: uppercase;

  font-size: 1.25rem;
  line-height: 1.25rem;
  text-transform: capitalize;
`;

export const Price = styled.span``;

export default PriceCaloriesTitle;
